import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { CorpLocationName, getCorpLocations } from "api/adminGroupService";

export interface UseGetCorpLocationsProps {
  corpAccountNbr: string;
  isLbaEnabled?: boolean;
}

export const useGetCorpLocations = ({
  corpAccountNbr,
  isLbaEnabled = true,
}: UseGetCorpLocationsProps): UseQueryResult<CorpLocationName[], Error> =>
  useQuery({
    queryKey: ["corpLocations", corpAccountNbr],
    queryFn: () => getCorpLocations(),
    enabled: isLbaEnabled && Boolean(corpAccountNbr),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
